import { Outlet } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AlertProvider from "../../../context/AlertContext";
import { AuthProvider } from "../../../context/AuthContext";
import { V2ThemeProvider } from "../../theme/V2ThemeProvider";

const popoutQueryClient = new QueryClient({
  defaultOptions: { queries: { retry: false } },
});

export default function PopoutShell() {
  return (
    <QueryClientProvider client={popoutQueryClient}>
      <AlertProvider>
        <AuthProvider>
          <V2ThemeProvider>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100vh",
              overflow: "hidden",
            }}
          >
            <Outlet />
          </div>
          </V2ThemeProvider>
        </AuthProvider>
      </AlertProvider>
    </QueryClientProvider>
  );
}
